var FSB = (function () {
  

  Utility.log('FeatureScondaryBlade---.js loaded');

  var size = $.noop;
  var $featuresSlick = $.noop;
  var imgs = [];
  var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  function setOnResize() {
    window.addEventListener('resize', resize);
    window.addEventListener('orientationchange', findImages);
  }

  function findImages() {
    imgs = [];
    imgs = $('.features-secondary').find('img');
    if (iOS) {
      $.each(imgs, function (index, value) {
        var url = $(imgs[index]).attr('data-pfsrc');
        $(imgs[index]).removeAttr('src');

        setTimeout(imageChanger($(imgs[index]), url), 3000);
      });
    }
  }

  function resize() {
    var width = window.innerWidth;
    var tiles;
    if (width < Constants.breakpoints.lg) {
      size = 'xs';
      tiles = $('.features-secondary').find('.tile');
      $.each(tiles, function (index) {
        $(tiles[index]).removeClass('tab-pane').removeClass('fade');
      });

      setSlick();

    } else {
      size = 'sm';
      tiles = $('.features-secondary').find('.tile');
      $.each(tiles, function (index) {
        $(tiles[index]).addClass('tab-pane')
          .addClass('fade')
          .removeAttr('style');
      });

      removeSlick();
    }

    findImages();
  }

  function imageChanger(_obj, _url) {
    if (_url && _url !== '') {
      $(_obj).removeAttr('src').attr('src', _url);
    }
  }

  function setSlick() {
    $featuresSlick = $('.component-featured-slick').slick({
      dots: true,
      useTransform: true,
    });
    addArrowsStyle();
  }

  function removeSlick() {
    if ($featuresSlick.length) {
      $('.component-featured-slick').slick('unslick');
      if ($('.component-featured-slick article').attr('style') === '') {
        $('.component-featured-slick article').each(function () {
          var bkg = $(this).data('acrVarCurrentResponsiveBkg');
          $(this).css('background-image', 'url(' + bkg + ')');
        });
      }
    }
  }

  function addArrowsStyle() {
    $('.slick-next', $featuresSlick)
      .addClass('acr-icon-arrow-large-right acr-f2 acr-black').text('');
    $('.slick-prev', $featuresSlick)
      .addClass('acr-icon-arrow-large-left acr-f2 acr-black').text('');
  }

  function init() {
    setOnResize();
    findImages();
    resize();
  }

  return {
    init: init,
  };
}());
